import {CalculatorBase} from "./CalculatorBase";
import {PriceTypeEnum} from "../../Fields/Core/FBFieldWithPriceBase.Options";
import {FixedAmountCalculator} from "./FixedAmountCalculator";
import {NumericUtilities} from "../../Utilities/NumericUtilities";
import {PercentageOriginalPriceAndOptionsCalculator} from "./PercentageOriginalPriceAndOptionsCalculator";
import {PercentageOriginalPriceCalculator} from "./PercentageOriginalPriceCalculator";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {FBDropDownModel} from "FreeFields/Fields/FBDropDown/FBDropDown.Model";


export class OptionsCalculator extends CalculatorBase{
    public SubCalculator:CalculatorBase;
    public OptionsTotal:{Id:number,Price:number,Quantity:number,RegularPrice:any,SalePrice:any,UnitPrice:any}[];

    constructor()
    {
        super();
        this.OptionsTotal=[];
    }



    InitializeFieldOnly(Field: FBFieldWithPriceBaseModel<any, any>) {
        super.InitializeFieldOnly(Field);
        this.Field.FormBuilder.PriceManager.FieldPriceUpdated.Subscribe(this,fieldUpdated=>{
            if(fieldUpdated==this.Field)
                return;
            let options= (this.Field as FBDropDownModel).GetSelectedOptions();
            if(options.find(x=>x.PriceType==PriceTypeEnum.percent_or_original_price_plus_options))
                this.ExecuteAndUpdate()

        });

        return this;
    }

    public GetDependsOnOtherFields(){
        return (this.Field as FBDropDownModel).GetSelectedOptions().some(x=>x.PriceType==PriceTypeEnum.percent_or_original_price_plus_options);
    }

    public ExecuteCalculation(value:null):{RegularPrice:any,SalePrice:any,Quantity:number}  {

        this.OptionsTotal=[];
        let selectedOption=(this.Field as FBDropDownModel).GetSelectedOptions();
        if (selectedOption.length == 0)
            return {RegularPrice: '', SalePrice: '',Quantity:0};



        for (let currentOption of selectedOption) {
            let result = null;
            switch (currentOption.PriceType) {
                case PriceTypeEnum.fixed_amount:
                    result = new FixedAmountCalculator().InitializeFieldOnly(this.Field).SetRegularPrice(currentOption.RegularPrice).SetSalePrice(currentOption.SalePrice).ExecuteCalculation('aa');
                    break;
                case PriceTypeEnum.percent_or_original_price_plus_options:
                    result =new PercentageOriginalPriceAndOptionsCalculator().InitializeFieldOnly(this.Field).SetRegularPercentage(currentOption.RegularPrice).SetSalePercentage(currentOption.SalePrice).ExecuteCalculation(' ');
                    break;
                case PriceTypeEnum.percent_of_original_price:
                    result =new PercentageOriginalPriceCalculator().InitializeFieldOnly(this.Field).SetRegularPercentage(currentOption.RegularPrice).SetSalePercentage(currentOption.SalePrice).ExecuteCalculation(' ');
                    break;
            }

            if (result == null)
                throw Error('Invalid price type ' + currentOption.PriceType);

            let optionsTotal:any={
                Id:currentOption.Id,
                SalePrice:result.SalePrice,
                RegularPrice:result.RegularPrice,
                UnitPrice:result.SalePrice==''?result.RegularPrice:result.SalePrice,
                Quantity:this.GetQuantityInput()
            };

            if(optionsTotal.UnitPrice=='')
                optionsTotal.UnitPrice=0;
            else
                optionsTotal.UnitPrice=parseFloat(optionsTotal.UnitPrice);
            if(isNaN(optionsTotal.UnitPrice))
                optionsTotal.UnitPrice=0;
            optionsTotal.Price=optionsTotal.UnitPrice*optionsTotal.Quantity;
            this.OptionsTotal.push(optionsTotal);




        }

        let priceToReturn = {RegularPrice: 0, SalePrice: 0,Quantity:0};
        priceToReturn.Quantity=this.GetQuantityInput();

        for(let total of this.OptionsTotal)
        {

            if(this.OptionsTotal.some(x=>x.SalePrice!=''))
            {
                priceToReturn.SalePrice+=NumericUtilities.ParseNumber(total.Price,0);
                priceToReturn.RegularPrice+=NumericUtilities.ParseNumber(total.RegularPrice,0);
            }else{
                priceToReturn.SalePrice=0;
                priceToReturn.RegularPrice+=NumericUtilities.ParseNumber(total.Price,0);
            }
        }


        return priceToReturn;

    }

    GetForceUpdateWhenFieldChange(): boolean {
        return true;
    }


    IsDynamic(): boolean {
        return (this.Field as FBDropDownModel).GetSelectedOptions().find(x=>x.PriceType==PriceTypeEnum.percent_or_original_price_plus_options)!=null;
    }

    public ParseNumber(number:any)
    {
        let num=parseFloat(number);
        if(isNaN(num))
            return 0;
        return num;
    }


    InternalInstanceUpdated(previousInstance: HTMLDivElement) {}


    private AddOption(original: { RegularPrice: string; SalePrice: string }, ammountToAdd: { RegularPrice: string; SalePrice: string }) {
        if(ammountToAdd.RegularPrice!='') {
            original.RegularPrice = NumericUtilities.ParseNumber(original.RegularPrice, 0) + NumericUtilities.ParseNumber(ammountToAdd.RegularPrice, 0);
        }

        if(ammountToAdd.SalePrice!='')
        {
            original.SalePrice = NumericUtilities.ParseNumber(original.SalePrice, 0) + NumericUtilities.ParseNumber(ammountToAdd.SalePrice, 0);
        }

        return original;
    }
}